module.exports = __webpack_public_path__ + "static/media/boop_icons.dc17dfca.gif";